// Mapeamento de verificação → endpoint de mapa do Diagnóstico.
// Reusa exatamente os mesmos endpoints rendarizados pelo back (Leaflet),
// não duplica renderer.
interface MapEndpoint {
  path: string;
  requiresImovel: boolean;
  label: string;
}

const MAP_ENDPOINTS: Record<string, MapEndpoint> = {
  prodes: { path: 'prodes-detalhe', requiresImovel: true, label: 'Mapa PRODES' },
  cnfp: { path: 'cnfp-detalhe', requiresImovel: true, label: 'Mapa CNFP' },
  ibama_embargo: {
    path: 'ibama-embargo-detalhe',
    requiresImovel: false,
    label: 'Detalhes IBAMA',
  },
  ibama_embargo_geo: {
    path: 'ibama-embargo-geo-detalhe',
    requiresImovel: true,
    label: 'Mapa IBAMA (geo)',
  },
  embargo_estadual: {
    path: 'embargo-estadual-detalhe',
    requiresImovel: true,
    label: 'Mapa embargo estadual',
  },
  icmbio_autos: {
    path: 'icmbio-autos-detalhe',
    requiresImovel: true,
    label: 'Mapa ICMBio · autos',
  },
  icmbio_embargos: {
    path: 'icmbio-embargos-detalhe',
    requiresImovel: true,
    label: 'Mapa ICMBio · embargos',
  },
  sobreposicao: {
    path: 'sobreposicao-detalhe',
    requiresImovel: true,
    label: 'Mapa sobreposição',
  },
};

export interface MapTarget {
  url: string;
  label: string;
}

export function mapTargetFor(
  verificacao: string | null | undefined,
  cpf: string,
  imovelId: number | null | undefined,
): MapTarget | null {
  if (!verificacao) return null;
  const cfg = MAP_ENDPOINTS[verificacao];
  if (!cfg) return null;
  if (cfg.requiresImovel && !imovelId) return null;
  const qs = imovelId ? `?imovel=${encodeURIComponent(String(imovelId))}` : '';
  return {
    url: `/api/v2/diagnostico/${encodeURIComponent(cpf)}/${cfg.path}${qs}`,
    label: cfg.label,
  };
}

// Tom para o Chip do status do diagnóstico.
export function statusTone(status: string | null | undefined) {
  if (status === 'irregular') return 'danger' as const;
  if (status === 'atencao') return 'warn' as const;
  if (status === 'regular') return 'ok' as const;
  return 'neutral' as const;
}
